import React from 'react';

const PrivacyPage = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="bg-white shadow sm:rounded-lg overflow-hidden">
        <div className="px-4 py-5 sm:px-6">
          <h1 className="text-2xl font-bold text-gray-900">Politique de Confidentialité</h1>
        </div>
        <div className="px-4 py-5 sm:p-6 prose max-w-none">
          <h2>1. Collecte des données</h2>
          <p>
            Nous collectons les données suivantes :
          </p>
          <ul>
            <li>Informations d'identification (email)</li>
            <li>Contenus générés (fiches, quiz)</li>
            <li>Données d'utilisation du service</li>
          </ul>

          <h2>2. Utilisation des données</h2>
          <p>
            Vos données sont utilisées pour :
          </p>
          <ul>
            <li>Fournir et améliorer nos services</li>
            <li>Personnaliser votre expérience</li>
            <li>Communiquer avec vous</li>
            <li>Assurer la sécurité de votre compte</li>
          </ul>

          <h2>3. Protection des données</h2>
          <p>
            Nous mettons en œuvre des mesures de sécurité appropriées pour protéger vos données contre tout accès,
            modification, divulgation ou destruction non autorisée. Les données collectées sont sauvegardés sur des
            serveurs sécurisés situés en Union Européenne.
          </p>

          <h2>4. Partage des données</h2>
          <p>
            Nous ne partageons vos données qu'avec :
          </p>
          <ul>
            <li>Les services nécessaires au fonctionnement de la plateforme</li>
            <li>Les autres utilisateurs (uniquement le contenu que vous choisissez de partager)</li>
          </ul>
          <p>
            Les données transmises à l'intelligence artificielle d'Open AI pour la création de la fiche de révision
            et d'un quiz sont anonymisées. Il appartient néanmoins à l'utilisateur de s'assurer qu'aucune information
            personnelle ne se trouve présente sur les documents joints à sa requête. Les données que vous transmettez
            peuvent être temporairement stockées par OpenAI à des fins de surveillance des abus, de sécurité et
            d'amélioration des services. NoStress Exams a toutefois désactivé l'utilisation des données pour
            l'entraînement de leurs modèles.
          </p>

          <h2>5. Vos droits</h2>
          <p>
            Conformément au RGPD, vous disposez des droits suivants :
          </p>
          <ul>
            <li>Droit d'accès à vos données</li>
            <li>Droit de rectification</li>
            <li>Droit à l'effacement</li>
            <li>Droit à la portabilité</li>
            <li>Droit d'opposition</li>
          </ul>

          <h2>6. Cookies</h2>
          <p>
            Nous utilisons des cookies pour améliorer votre expérience utilisateur et analyser
            l'utilisation de notre service.
          </p>

          <h2>7. Contact</h2>
          <p>
            Pour toute question concernant notre politique de confidentialité, contactez-nous à :{' '}
            <a 
              href="mailto:contact.nostressexams@gmail.com"
              className="text-secondary-600 hover:text-secondary-500"
            >
              contact.nostressexams@gmail.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;